module.exports = __webpack_public_path__ + "static/media/KRILL-USDC.f4414471.png";